<div class="notification__image-wrapper">
  <pp-icon class="notification__image" [ppSrc]="EIconPath.NOTIFICATION_ICON_IMAGE_360" ppColor="primary-950"></pp-icon>
</div>

@if (
  (ppNotification.changeBody.newValue &&
  ppNotification.changeBody.newValue.length > ppNotification.changeBody.oldValue.length) ||
  !ppNotification.changeBody.oldValue
  ) {
  @if (
    (!ppNotification.changeBody.oldValue && ppNotification.changeBody.newValue.length === 1) ||
    ppNotification.changeBody.newValue.length - ppNotification.changeBody.oldValue.length === 1
    ) {
    <span class="notification__blue-text">{{ 'added' | ppTranslate }}</span>
    {{ 'a' | ppTranslate }}
    <span class="notification__bold">{{ 'photo_360' | ppTranslate }}</span>
    {{ 'to_a_point_you' | ppTranslate }}
    {{ notificationReason }}.
  }
  @if (
    (!ppNotification.changeBody.oldValue && ppNotification.changeBody.newValue.length > 1) ||
    ppNotification.changeBody.newValue.length - ppNotification.changeBody.oldValue.length > 1
    ) {
    <span class="notification__blue-text">{{ 'added' | ppTranslate }}</span>
    {{
    ppNotification.changeBody.oldValue
    ? ppNotification.changeBody.newValue.length - ppNotification.changeBody.oldValue.length
    : ppNotification.changeBody.newValue.length
    }}
    <span class="notification__bold">{{ 'photos_360' | ppTranslate }}</span>
    {{ 'to_a_point_you' | ppTranslate }}
    {{ notificationReason }}. >
    <span class="notification__blue-text">{{ 'removed' | ppTranslate }}</span>
    a
    <span class="notification__bold">{{ 'photo_360' | ppTranslate }}</span>
    {{ 'from_a_point_you' | ppTranslate }}
    {{ notificationReason }}.
  }
  @if (
    (!ppNotification.changeBody.newValue && ppNotification.changeBody.oldValue.length > 1) ||
    ppNotification.changeBody.oldValue.length - ppNotification.changeBody.newValue.length > 1
    ) {
    <span class="notification__blue-text">{{ 'removed' | ppTranslate }}</span>
    {{
    ppNotification.changeBody.oldValue
    ? ppNotification.changeBody.newValue.length - ppNotification.changeBody.oldValue.length
    : ppNotification.changeBody.newValue.length
    }}
    <span class="notification__bold">{{ 'photos_360' | ppTranslate }}</span>
    {{ 'from_a_point_you' | ppTranslate }}
    {{ notificationReason }}.
  }
}
